module.exports = __webpack_public_path__ + "img/Spinning_House_Logo_Property.387b9ada.jpg";